// @ts-check
import picker from 'js-datepicker';

const datepicker = picker( 'input.date', {
    minDate: new Date(),
} );